import Carousel from "components/UI/Carousel/Carousel";

import "./AdvantagesSection.scss";

const AdvantagesSection = ({ slides, isMobile }) => (
  <section className="advantages-section">
    <div className="advantages-section_big">
      <div className="advantages-section_big-description">
        <h3 className="section__title">Только вы решаете, когда задача завершена</h3>
        <p className="section__text">Вы проверяете отчеты, а учет проектов всегда перед вами!</p>
      </div>
      <Carousel slides={slides} variant="coverflow" isMobile={isMobile} />
    </div>

    <div className="advantages-section_small">
      <div className="advantages-section_small-wrapper">
        <p className="advantages-section__subtitle">Отправим чек и договор</p>
        <p className="section__text">Безопасная оплата через Робокассу</p>
        <div className="advantages-section_small-wrapper-icon-left" />
      </div>

      <div className="advantages-section_small-wrapper">
        <p className="advantages-section__subtitle">Мы не используем ботов</p>
        <p className="section__text">Только живые исполнители</p>
        <div className="advantages-section_small-wrapper-icon-right" />
      </div>
    </div>
  </section>
);

export default AdvantagesSection;
